module.exports = __webpack_public_path__ + "assets/img/loading.38e583a4.gif";